import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MessageType, ServiceAppointment } from '@quorum/models/xs-resource';
import { ServiceLaneDropdownsFacade } from '@quorum/service-lane-dropdowns/facade';
import { ServiceLaneFacade } from '@quorum/service-lane-root/facade';

@Component({
  selector: 'svc-edit-customer-dialog',
  templateUrl: './edit-customer-dialog.component.html',
  styleUrls: ['./edit-customer-dialog.component.scss'],
})
export class EditCustomerDialogComponent implements OnInit {
  formSubmitted = false;
  phoneNumberMask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  overrideOptionsForm = this.formBuilder.group({
    excludeCommunicator: [this.dialogData.appointment.communicatorExcludeFrom],
    messagePreference: [null],
    messagePreferenceContactInfo: [null],
  });
  contactInfoPlaceholderText = 'Contact Info';

  constructor(
    public dialogRef: MatDialogRef<EditCustomerDialogComponent>,
    public dialog: MatDialog,
    public serviceLaneDropdownFacade: ServiceLaneDropdownsFacade,
    public serviceLaneFacade: ServiceLaneFacade,
    @Inject(MAT_DIALOG_DATA)
    public dialogData: {
      associateForm: FormGroup;
      addressForm: FormGroup;
      appointmentDropdowns: any;
      locations$: any;
      appointment: ServiceAppointment;
    },
    private formBuilder: FormBuilder
  ) {}

  ngOnInit(): void {
    // disable navigate and close modal if browser's back button clicked
    history.pushState(null, '');
    window.addEventListener('popstate', () => {
      this.cancel();
    });
  }

  changeContactInfoPlaceholder(messageTypePreferenceId: number, messageTypes: MessageType[]) {
    const messageType = new MessageType({
      ...messageTypes.find((mt) => mt.id === messageTypePreferenceId),
    });
    switch (messageType.description) {
      case 'Email':
        this.contactInfoPlaceholderText = 'Email';
        break;
      case 'Text':
        this.contactInfoPlaceholderText = 'Cell Phone';
        break;
      default:
        this.contactInfoPlaceholderText = 'Contact Information';
    }
  }

  cancel() {
    this.dialogRef.close();
  }

  save(associateForm: FormGroup, addressForm: FormGroup, overrideOptionsForm: FormGroup) {
    this.formSubmitted = true;

    addressForm.get('cellPhoneNumber').clearValidators();
    addressForm.get('cellPhoneNumber').updateValueAndValidity({ emitEvent: false });
    associateForm.get('emailAddress').clearValidators();
    associateForm.get('emailAddress').updateValueAndValidity({ emitEvent: false });

    // Set e-mail address or cell phone number as required depending on message preference
    if (associateForm.get('messagePreferenceId').value === 1) {
      associateForm.get('emailAddress').setValidators(Validators.required);
      associateForm.get('emailAddress').updateValueAndValidity({ emitEvent: false });
    }
    if (associateForm.get('messagePreferenceId').value === 2) {
      addressForm.get('cellPhoneNumber').setValidators(Validators.required);
      addressForm.get('cellPhoneNumber').updateValueAndValidity({ emitEvent: false });
    }

    // Ensure all phone number inputs are 10 digits in length
    if (
      addressForm.get('cellPhoneNumber').value &&
      addressForm.get('cellPhoneNumber').value.replace(/\D/g, '').length != 10
    ) {
      addressForm.get('cellPhoneNumber').setErrors({ invalidPhoneNumberLength: true });
    }
    if (
      addressForm.get('homePhoneNumber').value &&
      addressForm.get('homePhoneNumber').value.replace(/\D/g, '').length != 10
    ) {
      addressForm.get('homePhoneNumber').setErrors({ invalidPhoneNumberLength: true });
    }
    if (
      overrideOptionsForm.get('messagePreference').value === 2 &&
      overrideOptionsForm.get('messagePreferenceContactInfo').value &&
      overrideOptionsForm.get('messagePreferenceContactInfo').value.replace(/\D/g, '').length != 10
    ) {
      overrideOptionsForm.get('messagePreferenceContactInfo').clearValidators();
      overrideOptionsForm.get('messagePreferenceContactInfo').updateValueAndValidity({ emitEvent: false });
      overrideOptionsForm.get('messagePreferenceContactInfo').setErrors({ invalidPhoneNumberLength: true });
    }

    // Ensure all email inputs are valid
    if (
      overrideOptionsForm.get('messagePreference').value === 1 &&
      overrideOptionsForm.get('messagePreferenceContactInfo').value
    ) {
      overrideOptionsForm.get('messagePreferenceContactInfo').setValidators([Validators.email]);
      overrideOptionsForm.get('messagePreferenceContactInfo').updateValueAndValidity({ emitEvent: false });
    }
    if (associateForm.get('emailAddress').value) {
      associateForm.get('emailAddress').setValidators([Validators.email]);
      associateForm.get('emailAddress').updateValueAndValidity({ emitEvent: false });
    }

    // Ensure customer associate message preference is set to something other than None/null before override can be configured
    if (
      [null, 4].includes(associateForm.get('messagePreferenceId').value) &&
      [1, 2, 3].includes(overrideOptionsForm.get('messagePreference').value)
    ) {
      overrideOptionsForm.get('messagePreference').setErrors({ messagePreferenceRequired: true });
    }

    associateForm.markAllAsTouched();
    addressForm.markAllAsTouched();
    overrideOptionsForm.markAllAsTouched();

    if (associateForm.valid && addressForm.valid && overrideOptionsForm.valid) {
      this.dialogRef.close({ associateForm, addressForm, overrideOptionsForm });
    }
  }
}
